import React, { useState, useEffect } from 'react';
import posthog from 'posthog-js';
import * as Sentry from "@sentry/react";

// ΦΡΟΥΡΟΣ: Βεβαιωνόμαστε ότι το Sentry & PostHog θα τρέξουν ΜΟΝΟ ΜΙΑ ΦΟΡΑ ανά session
let isAnalyticsStarted = false;

const startAnalytics = () => {
  if (isAnalyticsStarted) return; // Αν έχουν ήδη τρέξει, μην κάνεις τίποτα
  
  console.log("Ο χρήστης έδωσε συγκατάθεση. Ξεκινάμε Sentry & PostHog.");
  isAnalyticsStarted = true;
  
  // 1. Αρχικοποίηση PostHog
  posthog.init('phc_9YTi2wzVND4e7IlCLHkbmHFwDT9pHfI1lTb4R2n4hXT', { 
    api_host: 'https://eu.i.posthog.com',
    autocapture: true 
  });

  // 2. Αρχικοποίηση Sentry
  Sentry.init({
    dsn: "https://ad4de3305f3eaca090e82829739ef725@o4511106632908800.ingest.de.sentry.io/4511106651193424",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 1.0, 
    // ΔΙΟΡΘΩΣΗ: 0.0 για να σταματήσει να καταναλώνει τα δωρεάν Replays σε απλές επισκέψεις
    replaysSessionSampleRate: 0.0, 
    // Παραμένει 1.0 για να γράφει βίντεο ΜΟΝΟ όταν συμβαίνει κάποιο error
    replaysOnErrorSampleRate: 1.0, 
  });
};

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);
  const [lang, setLang] = useState("el");

  useEffect(() => {
    if (navigator.language && !navigator.language.startsWith("el")) {
      setLang("en");
    }
    
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setIsVisible(true);
    } else if (consent === 'accepted') {
      // Αν έχει ήδη δεχτεί σε προηγούμενη επίσκεψη, ξεκινάμε τα analytics
      startAnalytics();
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setIsVisible(false);
    startAnalytics(); // Ξεκινάνε όλα με ασφάλεια!
  };

  const handleReject = () => {
    localStorage.setItem('cookie_consent', 'rejected');
    setIsVisible(false);
    // Ο χρήστης αρνήθηκε.
    if (isAnalyticsStarted) {
       posthog.opt_out_capturing(); 
    }
  };

  if (!isVisible) return null;

  return (
    <div className="print:hidden fixed bottom-0 left-0 right-0 bg-gray-900 border-t border-gray-700 p-4 shadow-[0_-10px_40px_rgba(0,0,0,0.5)] z-[999] text-white flex flex-col md:flex-row items-center justify-between gap-4 animate-fade-in">
      
      <div className="flex flex-col md:flex-row items-center gap-4 w-full md:w-auto">
        <div className="flex bg-gray-800 p-1 rounded-lg shrink-0 self-start md:self-center">
          <button onClick={() => setLang("el")} className={`px-2 py-1 rounded-md text-[10px] font-black uppercase transition-all ${lang === "el" ? "bg-gray-600 text-white shadow-sm" : "text-gray-400 hover:text-white"}`}>GR</button>
          <button onClick={() => setLang("en")} className={`px-2 py-1 rounded-md text-[10px] font-black uppercase transition-all ${lang === "en" ? "bg-gray-600 text-white shadow-sm" : "text-gray-400 hover:text-white"}`}>EN</button>
        </div>

        <div className="text-xs font-medium text-gray-400 text-center md:text-left">
          {lang === "el" ? (
            <>
              <strong className="text-white text-sm">Πολιτική Απορρήτου & Cookies 🍪</strong><br/>
              Χρησιμοποιούμε cookies για την ανάλυση της επισκεψιμότητας (Sentry/PostHog) και τη βελτίωση της εμπειρίας σας. Τα δεδομένα συλλέγονται ανώνυμα.
              <a href="/privacy" className="text-blue-400 hover:text-blue-300 underline ml-1">Μάθετε περισσότερα.</a>
            </>
          ) : (
            <>
              <strong className="text-white text-sm">Privacy & Cookies Policy 🍪</strong><br/>
              We use cookies to analyze traffic (Sentry/PostHog) and improve your experience. Data is collected anonymously.
              <a href="/privacy" className="text-blue-400 hover:text-blue-300 underline ml-1">Learn more.</a>
            </>
          )}
        </div>
      </div>

      <div className="flex gap-3 w-full md:w-auto shrink-0">
        <button 
          onClick={handleReject} 
          className="flex-1 md:flex-none px-6 py-3 rounded-2xl border border-gray-600 text-gray-300 font-bold text-xs uppercase hover:bg-gray-800 transition-colors"
        >
          {lang === "el" ? "Απορριψη" : "Reject"}
        </button>
        <button 
          onClick={handleAccept} 
          className="flex-1 md:flex-none px-6 py-3 rounded-2xl bg-blue-600 text-white font-black text-xs uppercase hover:bg-blue-500 shadow-lg shadow-blue-500/20 transition-transform active:scale-95"
        >
          {lang === "el" ? "Αποδοχη" : "Accept"}
        </button>
      </div>
    </div>
  );
}
